import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-right-arrow-icon',
  templateUrl: './right-arrow-icon.component.html',
  styleUrls: ['./right-arrow-icon.component.scss']
})
export class RightArrowIconComponent {

  constructor() { }

  ngOnInit() {
  }

}
